// extracted by mini-css-extract-plugin
module.exports = {"styledTitleCell":"bQenU1KL","styledDescriptionCell":"eLEIiKDU","styledRatingPill":"NBDnQRg0","valueCell":"mufrXIm6","title":"BX4YZpk0"};